import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import UsePageTitle from './components/TitlePage';
import routes from './Routes';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-background relative">
        <UsePageTitle />
        
        <Header />
        <main className="flex-1">
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
